import { setDeploymentNecessary } from "../../actions";
import Spinner from "../../controls/Spinner";
import Toggle from "../../controls/Toggle";
import { ComponentEx, connect, PureComponentEx, translate, } from "../../controls/ComponentEx";
import * as fs from "../../util/fs";
import { truthy } from "../../util/util";
import { setINITweakEnabled } from "../mod_management/actions/mods";
import { INI_TWEAKS_PATH } from "../mod_management/InstallManager";
import { installPath } from "../mod_management/selectors";
import { activeGameId } from "../profile_management/selectors";
import Bluebird from "bluebird";
import * as path from "path";
import * as React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { useSelector } from "react-redux";
class Tweak extends PureComponentEx {
    render() {
        const { enabled, fileName } = this.props;
        const match = fileName.match(/(.*)\[(.*)\]\.ini/);
        if (!truthy(match) || match.length < 2) {
            return null;
        }
        return (React.createElement(ListGroupItem, { className: "listitem-tweak" },
            React.createElement(Toggle, { checked: enabled, onToggle: this.toggle }, match[1])));
    }
    toggle = (enabled) => {
        const { fileName, onToggle } = this.props;
        onToggle(fileName, enabled);
    };
}
class TweakList extends ComponentEx {
    render() {
        const { t, tweaks, mod } = this.props;
        if (tweaks.length === 0 || mod === undefined) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("label", { className: "control-label" }, t("Ini Tweaks")),
            React.createElement(ListGroup, null, tweaks.map(this.renderTweak))));
    }
    renderTweak = (fileName) => {
        const { mod } = this.props;
        const isEnabled = (mod.enabledINITweaks ?? []).includes(fileName);
        return (React.createElement(Tweak, { key: `tweak-${fileName}`, fileName: fileName, enabled: isEnabled, onToggle: this.toggle }));
    };
    toggle = (fileName, enabled) => {
        const { gameMode, mod, onSetDeploymentNecessary, onSetINITweakEnabled } = this.props;
        onSetINITweakEnabled(gameMode, mod.id, fileName, enabled);
        onSetDeploymentNecessary(gameMode, true);
    };
}
function mapStateToProps(state, ownProps) {
    const gameMode = activeGameId(state);
    return {
        gameMode,
        mod: state.persistent.mods[gameMode]?.[ownProps.modId],
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetINITweakEnabled: (gameId, modId, tweak, enabled) => {
            dispatch(setINITweakEnabled(gameId, modId, tweak, enabled));
        },
        onSetDeploymentNecessary: (gameId, required) => {
            dispatch(setDeploymentNecessary(gameId, required));
        },
    };
}
const TweakListConnected = translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(TweakList));
function TweakListWrap(props) {
    const { modId, getTweaks } = props;
    const [curTweaks, setCurTweaks] = React.useState(null);
    const gameMode = useSelector(activeGameId);
    const modsPath = useSelector(installPath);
    const mod = useSelector((state) => state.persistent.mods[gameMode]?.[modId]);
    React.useEffect(() => {
        getTweaks(modsPath, mod).then((tweakList) => {
            setCurTweaks(tweakList);
        });
    }, [modId, modsPath, getTweaks]);
    if (curTweaks === null) {
        return React.createElement(Spinner, null);
    }
    else {
        return React.createElement(TweakListConnected, { modId: modId, tweaks: curTweaks });
    }
}
const renderINITweaks = (() => {
    const tweakLists = {};
    const getTweakList = (modsPath, mod) => {
        if (mod?.installationPath === undefined) {
            return Bluebird.resolve([]);
        }
        if (tweakLists[mod.id] === undefined &&
            mod?.installationPath !== undefined) {
            const tweaksPath = path.join(modsPath, mod.installationPath, INI_TWEAKS_PATH);
            tweakLists[mod.id] = fs.readdirAsync(tweaksPath).catch(() => []);
        }
        return tweakLists[mod.id];
    };
    return (mod) => {
        return React.createElement(TweakListWrap, { modId: mod.id, getTweaks: getTweakList });
    };
})();
export default renderINITweaks;
